import { PaymentGateway } from '../../../../../services/exports/Constants';

export default {
  title: 'Fai clic sul pulsante qui sotto per rivedere e confermare le informazioni di pagamento.',
  payment_gateways: {
    [PaymentGateway.Stripe]: {
      description:
        'Collaboriamo con Stripe per gestire i pagamenti. Stripe è la piattaforma di pagamento più sicura, utilizzata dalle maggiori aziende in tutto il mondo.',
      form: {
        terms_acceptance: {
          label:
            'Procedendo, accetti il nostro <FoodAmigosTerms>Contratto di servizio</FoodAmigosTerms> e il <StripeTerms>Contratto per account connessi Stripe.</StripeTerms>',
        },
      },
      labels: {
        stripe_requirements:
          'Stripe ha segnalato alcune informazioni del cliente come mancanti o non valide. Correggi i seguenti errori facendo clic sul pulsante «Apri profilo Stripe»:',
        errors: 'Errori',
        awaiting_verification: 'Il tuo account Stripe è in fase di verifica',
        awaiting_verification_description:
          'Stiamo attendendo che Stripe completi la verifica della tua attività. Nel frattempo puoi consultare il tuo profilo.',
      },
    },
    [PaymentGateway.Adyen]: {
      description:
        'Collaboriamo con Adyen per la gestione dei pagamenti. Adyen è una delle piattaforme di pagamento più sicure, utilizzata dalle più grandi aziende al mondo.',
    },
  },
  labels: {
    verified: 'Il tuo account {{paymentGateway}} è verificato',
    verified_description:
      'La verifica per {{paymentGateway}} è completata. Puoi comunque gestire il tuo profilo se necessario.',
  },
  buttons: {
    proceed: 'Conferma le mie informazioni di pagamento',
    copy_link: 'Copia link',
  },
  toasts: {
    something_went_wrong: 'Si è verificato un errore, contatta il supporto tecnico',
  },
};
